/**
 * The 2 most basic roles a user can have
 * You can just use this enum, or...
 * If you have more advanced users, you can extend this enum like this:
 * type advancedRoles = basicRoles | 'advancedUser'
 */
enum basicRoles {
    Client = 'Client',
    StuartStaff = 'StuartStaff',
    API = 'API',
    SE = 'SE',
}

export default basicRoles;
